import React from 'react'

export default function Wholesale() {
  return (
    <div>Wholesale</div>
  )
}
